(function () {
    "use strict";

    angular
        .module("app.product")
        .controller("ProductController", ProductController);

    ProductController.$inject = [
        "$rootScope",
        "$window",
        "$timeout",
        "$scope",
        "CartService",
        "ProductService",
        "$httpParamSerializer",
    ];

    function ProductController(
        $rootScope,
        $window,
        $timeout,
        $scope,
        CartService,
        ProductService,
        $httpParamSerializer
    ) {
        /* jshint validthis:true */
        var vm = this;
        vm.productData = {};
        vm.productList = [];
        vm.defaultfilterDataFilter = {};
        vm.productCompareStatus = {};
        vm.nextPageLink = window.location.origin + window.location.pathname;
        vm.currentPageLink = window.location.origin + window.location.pathname;
        vm.maxPageIndex = 2;
        vm.defaultCurrencyFormat = "";
        vm.defaultFilter = {
            PageSize: 20,
            PageIndex: 1,
            SortProperty: "DisplayOrder",
            SortType: "asc",
            IsVisibleIndividually: true,
            Active: true,
            Variant: true,
        };
        vm.filter = {};
        vm.loadingMoreProducts = true;
        vm.loadingFilterData = true;
        vm.filterOpen = [];
        vm.dynamicFilter = true;

        function activate() {
            var $windowElement = angular.element(window);
            var $loadMore = $(".load-more-products")[0];
            if ($loadMore) {
                $windowElement.bind("scroll", function (e) {
                    var windowScrollTop =
                        $windowElement.scrollTop() + $windowElement.height();
                    var loadMoreOffsetTop = $($loadMore).offset().top;
                    if (
                        windowScrollTop > loadMoreOffsetTop &&
                        !vm.loadingMoreProducts &&
                        vm.maxPageIndex > vm.filter.PageIndex
                    ) {
                        vm.getProducts();
                    }
                });
            }
        }
        vm.init = function (productFilter) {
            if (productFilter) {
                var excludeList = [
                    "IsSearch",
                    "IsPanel",
                    "FilteredCount",
                    "Count",
                    "UseCache",
                ];
                var baseProductFilter = Object.fromEntries(
                    Object.entries(productFilter)
                        .filter((x) => !excludeList.includes(x[0]))
                        .filter(([_, v]) => v != null)
                );
                vm.defaultFilter = Object.assign(
                    vm.defaultFilter,
                    baseProductFilter
                );
            }
            var urlparams = getParams($window.location.href);
            var urlParamObject = Object.assign(vm.defaultFilter, urlparams);
            vm.filter = angular.copy(urlParamObject);
            vm.filter.PageIndex = 1;
            setTimeout(() => {
                vm.getProducts();
                vm.getFilterData();
            }, 100);
        };

        vm.getProducts = function (clearFilter) {
            vm.loadingMoreProducts = true;
            vm.currentPageLink =
                $window.location.pathname +
                "?" +
                $httpParamSerializer(vm.filter);
            $window.history.pushState(
                {},
                $window.pageTitle,
                vm.currentPageLink
            );
            var filterModel = clearFilter
                ? vm.defaultFilter
                : prepareFilterModel(vm.filter);
            filterModel.CultureId = vm.currentCulture;

            return ProductService.filter(filterModel).then(function (response) {
                vm.productData = response;
                vm.productListCount = response.FilteredCount;
                vm.productList = vm.productList.concat(response.Data);
                if (vm.productList.length <= 0) {
                    $(".products-container").addClass("no-product-ajax");
                } else {
                    $(".products-container").removeClass("no-product-ajax");
                }
                vm.checkFavorite(vm.productList);
                vm.filter.PageIndex = response.PageIndex;
                vm.activateLazyLoading();
                vm.maxPageIndex =
                    response.FilteredCount / response.PageSize + 1;
                vm.filter.PageIndex = vm.filter.PageIndex + 1;
                vm.loadingMoreProducts = false;
                vm.nextPageLink =
                    $window.location.origin +
                    $window.location.pathname +
                    "?" +
                    $httpParamSerializer(vm.filter);
            });
        };

        vm.checkFavorite = function (productList) {
            for (let index = 0; index < productList.length; index++) {
                if (vm.IsInFavorite(productList[index])) {
                    productList[index].IsInFavorite = true;
                } else {
                    productList[index].IsInFavorite = false;
                }
            }
        };

        function prepareFilterModel(filters) {
            var filterModel = {};
            Object.keys(filters).forEach(function (key) {
                var value = filters[key];
                if (value) {
                    if (Array.isArray(value) && value.length > 0) {
                        filterModel[key] = value + "";
                    } else {
                        filterModel[key] = value;
                    }
                }
            });
            return filterModel;
        }

        vm.getFilterData = function (clearFilter) {
            vm.loadingFilterData = true;
            var filter;
            if (clearFilter) {
                filter = vm.defaultFilter;
            } else {
                filter = vm.filter;
            }
            var filterDataFilter = Object.assign(
                filter,
                vm.defaultfilterDataFilter
            );
            if (vm.filter.PageIndex) {
                ProductService.getFilterData(filterDataFilter)
                    .then(function (response) {
                        vm.filterData = response;
                        vm.loadingFilterData = false;
                    })
                    .catch(function (error) {
                        vm.loadingFilterData = false;
                    });
            }

        };

        vm.toggleSelection = function (dataListName, brand) {
            if (!vm.filter[dataListName]) {
                vm.filter[dataListName] = [];
            }
            var idx = vm.filter[dataListName].indexOf(brand);
            if (idx > -1) {
                vm.filter[dataListName].splice(idx, 1);
            } else {
                try {
                    vm.filter[dataListName].push(brand);
                } catch (e) {
                    vm.filter[dataListName] = [brand];
                }
            }
            vm.filterAll();
        };

        vm.filterAll = function (isPrice) {
            vm.filter.PageIndex = 1;
            if (isPrice != true) {
                vm.filter.MinPrice = undefined;
                vm.filter.MaxPrice = undefined;
            }
            vm.productList = [];
            setTimeout(function () {
                if (vm.dynamicFilter) {
                    vm.getFilterData();
                }
                vm.getProducts().then(function () {
                    vm.getRealFilter();
                });
            }, 300);
        };

        vm.sort = function (sortText) {
            var SortProperty = sortText.split("_")[0];
            var SortType = sortText.split("_")[1];
            vm.filter.SortProperty = SortProperty;
            vm.filter.SortType = SortType;
            vm.filter.PageIndex = 1;
            vm.productList = [];
            vm.getProducts();
        };

        vm.clearFilter = function (dataListName, item) {
            var filterList =
                vm.filter[dataListName] == null || vm.filter[dataListName] == []
                    ? []
                    : String(vm.filter[dataListName]);

            if (typeof filterList === "string") {
                filterList = filterList.split(",");
            }

            if (typeof item !== "string") {
                item = item.join(",");
            }
            var idx = filterList.indexOf(item);

            if (idx > -1) {
                filterList.splice(idx, 1);
            }

            vm.filter[dataListName] = filterList;

            var lastCount = 0;
            var filterCount = vm.realFilter;
            if (filterCount.length > 0) {
                for (var i = 0; i < filterCount.length; i++) {
                    lastCount += filterCount[i][1].length;
                }
            } else {
                vm.filter = angular.copy(vm.defaultFilter);
            }
            if (lastCount < 1) {
                vm.filter = angular.copy(vm.defaultFilter);
            }
            vm.filterAll();
        };

        vm.clearAllFilter = function () {
            vm.filter = angular.copy(vm.defaultFilter);
            vm.productList = [];
            vm.getFilterData(true);
            vm.getProducts().then(function () {
                vm.getRealFilter();
            });
        };

        vm.isString = function (filterValue) {
            return typeof filterValue == "string";
        };

        vm.getRealFilter = function () {
            var excludeList = [
                "PageSize",
                "PageIndex",
                "BrandNormalizedName",
                "CategoryNormalizedName",
                "IsVisibleIndividually",
                "SortProperty",
                "MinPrice",
                "MaxPrice",
                "SortType",
                "Active",
                "Variant",
                "gad_source",
                "gclid",
                "fbclid",
                "_escaped_fragment_",
                "utm_medium",
                "utm_campaign",
                "utm_term",
                "utm_content",
            ];
            var filteredObject = Object.entries(vm.filter)
                .filter((x) => !excludeList.includes(x[0]))
                .filter((x) => x.length > 1)
                .map((x) => {
                    var data = [];
                    data[0] = x[0];
                    data[1] = x[1].toString() + "";
                    return data;
                })
                .filter((x) => x.length > 1)
                .filter((x) => x[1] != undefined && x[1].length > 0);
            vm.realFilter = filteredObject;
        };
        $scope.$watch(vm.filter, function () {
            vm.getRealFilter();
        });

        vm.activateLazyLoading = function () {
            $timeout(function () {
                $("img.lazy:not(.loaded)")
                    .lazyload({
                        effect: "fadeIn",
                    })
                    .addClass("loaded");
            });
        };

        vm.getDataFromJson = function (json, key) {
            if (!json) {
                return "";
            }
            return JSON.parse(json)[key];
        };

        vm.getMainImage = function (product) {
            if (product.FirstImage) {
                return product.FirstImage;
            }
            var mainMedia =
                product.ProductMedia.find(function (media) {
                    return media.IsMain === true;
                }) || product.ProductMedia[0];
            if (mainMedia) {
                return mainMedia.Media.FullPath;
            } else {
                return "no-image.png";
            }
        };

        vm.getSecondImage = function (product) {
            var mainMedias = product.ProductMedia.filter(function (media) {
                return media.IsMain === true;
            });
            var mainMedia =
                mainMedias && mainMedias.length > 1
                    ? mainMedias[1]
                    : mainMedias[0] || product.ProductMedia[0];
            if (mainMedia) {
                return mainMedia.Media.FullPath;
            } else {
                return "no-image.png";
            }
        };

        vm.getMainPrice = function (product) {
            var price = product.Price;
            var priceWithDiscount = product.PriceWithDiscount;
            var defaultPrice = product.Price;
            if (product.Currency.Default == false) {
                if (priceWithDiscount != price) {
                    defaultPrice = priceWithDiscount * product.Currency.Rate;
                } else {
                    defaultPrice = price * product.Currency.Rate;
                }
            }
            return defaultPrice;
        };

        vm.getCalculatePrice = function (product, discount) {
            var price = product.Price;
            var priceWithDiscount = product.PriceWithDiscount;
            var defaultPrice = product.Price;
            if (discount == 1) {
                defaultPrice = priceWithDiscount * product.Currency.Rate;
            } else if (discount == 0) {
                defaultPrice = price * product.Currency.Rate;
            } else if (discount == 2) {
                defaultPrice =
                    product.CurrentDiscount.Amount * product.Currency.Rate;
            }
            return defaultPrice;
        };

        vm.isSimple = function (product) {
            if (
                product &&
                (product.IsMainGroupProduct ||
                    (product.HasOptions &&
                        product.HasVariants &&
                        product.IsMainVariantProduct))
            ) {
                return true;
            } else {
                return false;
            }
        };

        vm.getProductVariants = function (product) {
            var productVariant = "";
            if (
                product.BaseProductId &&
                product.ProductOptionValue.length > 0
            ) {
                var options = product.ProductOptionValue.filter(function (
                    item
                ) {
                    return item.IsSpesific == true;
                }).sort(function (a, b) {
                    return a.Option.DisplayOrder - b.Option.DisplayOrder;
                });
                var optionDictionary = {};
                for (let i = 0; i < options.length; i++) {
                    const item = options[i];
                    optionDictionary[item.Option.Name] = item.OptionValue.Value;
                }
                productVariant = JSON.stringify(optionDictionary);
            }
            return productVariant;
        };

        function getParams(url) {
            var params = {};
            var parser = document.createElement("a");
            parser.href = url;
            var query = parser.search.substring(1);
            var vars = query.split("&");
            for (var i = 0; i < vars.length; i++) {
                var pair = vars[i].split("=");

                if (pair[0]) {
                    if (params[pair[0]]) {
                        if (Array.isArray(params[pair[0]])) {
                            params[pair[0]].push(
                                decodeURIComponent(
                                    (pair[1] || "").replace(/\+/g, "%20")
                                )
                            );
                        } else {
                            params[pair[0]] = [
                                params[pair[0]],
                                decodeURIComponent(
                                    (pair[1] || "").replace(/\+/g, "%20")
                                ),
                            ];
                        }
                    } else {
                        params[pair[0]] = decodeURIComponent(
                            (pair[1] || "").replace(/\+/g, "%20")
                        );
                    }
                }
            }
            return params;
        }

        vm.getValue = function (object, key) {
            return object[key];
        };
        vm.toggleFilterOpen = function (element) {
            $(".newfilter").removeClass("active");
            element.currentTarget.classList.add("active");
            $(".newfilter").removeClass("on");
            if (element.currentTarget.classList.contains("active")) {
                element.currentTarget.classList.add("on");
            }
        };
        $(document).click(function (event) {
            if (
                event.target.offsetParent &&
                !event.target.offsetParent.classList.contains("newfilter")
            ) {
                $(".newfilter").removeClass("on");
            }
        });
        vm.changeVariantImage = function (image1, image2, element) {
            $(element.currentTarget.offsetParent)
                .find(".product-image img")

                .attr("src", image1);
            $(element.currentTarget.offsetParent)
                .find(".product-box__first-image")
                .attr("src", image1);
            $(element.currentTarget.offsetParent)
                .find(".product-box__sec-image")
                .attr("src", image2);
        };

        vm.ScreenSize = window.innerWidth;

        $scope.$watchCollection("[vm.productList,vm.filterData]", function () {
            var activateGtm = new ActivateGtm();
            activateGtm.activateViewListProduct();
        });

        vm.getFavoriteProducts = function (product) {
            if ($rootScope.favoriteCart) {
                var favoriteProductList = $rootScope.favoriteCart.CartProduct;
                var filterFavorites = favoriteProductList.filter(function (
                    item
                ) {
                    return item.ProductId.includes(product.Id);
                });
                return filterFavorites;
            } else {
                return [];
            }
        };

        vm.IsInFavorite = function (product) {
            var editFavCartProduct = vm.getFavoriteProducts(product);
            if (editFavCartProduct.length > 0) {
                return true;
            }
            return false;
        };

        vm.checkIfInCompare = function (productId) {
            $.Cart.IsInCart({
                ProductId: productId,
                CartType: 'Compare'
            }).then(function (response) {
                vm.productCompareStatus[productId] = response; // Her productId için durumu saklıyoruz
            }).catch(function (error) {
                console.error("Error checking compare status:", error);
            });
        };

        vm.DeleteFavoriteCartProduct = function (product) {
            var editFavCartProduct = vm.getFavoriteProducts(product);
            if (editFavCartProduct.length > 0) {
                CartService.Delete(editFavCartProduct[0]).then(function () {
                    CartService.getCart({ CartType: "Favorite" }).then(
                        function (_cart) {
                            $rootScope.favoriteCart = _cart;
                            vm.checkFavorite(vm.productList);
                        }
                    );
                });
            }
        };

        vm.AddFavoriteCartProduct = function (product) {

            if (userId) {
                var editFavCartProduct = vm.getFavoriteProducts(product);
                if (editFavCartProduct.length == 0) {
                    var params = {
                        productID: product.Id,
                        CartType: "Favorite",
                    };
                    CartService.InsertWithParams(params).then(function () {
                        CartService.getCart({ CartType: "Favorite" }).then(
                            function (_cart) {
                                $rootScope.favoriteCart = _cart;
                                var elemetn1 = $('[data-id="' + product.Id + '"]');
                                var closestSibling = elemetn1.siblings('.product-successfully-add-box');
                                var successTextElement = closestSibling.find('.FavoriteText');
                                console.log(successTextElement);
                                successTextElement.css({ "display": "" });
                                setTimeout(function () {
                                    successTextElement.css({ "display": "none" });
                                }, 2000);

                                vm.checkFavorite(vm.productList);
                            }
                        );
                    });
                }
            }
            else {
                window.location.href = "/account/loginorsignup";
            }


        };

        vm.getTagClass = function (product) {
            var getTagList = "";
            if (product.ProductTag.length > 0) {
                for (
                    let index = 0;
                    index < product.ProductTag.length;
                    index++
                ) {
                    getTagList += product.ProductTag[index].Tag.Name + " ";
                }
            }
            return getTagList;
        };

        vm.getRelatedProductList = function (productId, relatedProductTypeId) {

            vm.gridClass = 'grid-frame-column-4-row-1';
            vm.list = 'false'
            vm.relatedProductList = vm.relatedProductList || {};
            ProductService.getRelatedProductList({
                ProductId: productId,
                RelatedProductTypeId: relatedProductTypeId,
            }).then(function (data) {
                vm.checkFavorite(data.data);
                vm.relatedProductList[relatedProductTypeId] = data.data || [];
            });
        };

        vm.getDataFromJsonObject = function (json) {
            try {
                return JSON.parse(json);
            } catch (e) {
                return [];
            }
        };

        vm.getJsonTotalVal = function (json, key) {
            if (!json) {
                return 0;
            }
            return JSON.parse(json).reduce((sum, item) => {
                if (item.hasOwnProperty(key)) {
                    return sum + item[key];
                }
                return sum;
            }, 0);
        }

        vm.calculateDiscountAmount = function (price, cartPrice) {
            if (price && cartPrice && price > 0 && cartPrice > 0) {

                var discountPercentage = 100 - ((cartPrice / price) * 100);

                var discountAmount = price - cartPrice;

                return {
                    discountPercentage: discountPercentage,
                    discountAmount: discountAmount
                };
            } else {
                return {
                    discountPercentage: 0,
                    discountAmount: 0
                };
            }
        }


        activate();
    }
})();
